// DS: i3.16
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Trashcan: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 1a1 1 0 011 1h4a1 1 0 110 2v8.532a1 1 0 01-.36.768l-1.762 1.468a1 1 0 01-.64.232H4.762a1 1 0 01-.64-.232L2.36 13.3a1 1 0 01-.36-.768V4a1 1 0 010-2h4a1 1 0 011-1h2zm3 3H4v8.063L5.124 13h5.751L12 12.062V4zM6 6a1 1 0 011 1v3a1 1 0 11-2 0V7a1 1 0 011-1zm4 0a1 1 0 011 1v3a1 1 0 11-2 0V7a1 1 0 011-1z"
        clipRule="evenodd"
      />
    </svg>
  </IconWrap>
);
Trashcan.displayName = 'Trashcan';

export default Trashcan;
